/** Telegram-контакт администратора. Один URL на все клиенты. */
export const SUPPORT_TELEGRAM_USERNAME = 'NikosEnergy';
export const SUPPORT_TELEGRAM_URL = `https://t.me/${SUPPORT_TELEGRAM_USERNAME}`;

/**
 * Чат с поддержкой с готовым текстом. На iOS Telegram черновик из mini-app не
 * вставляет — кнопка дополнительно кладёт текст в буфер (copyDraftAndPrompt).
 */
export function supportChatUrl(text: string): string {
  return `${SUPPORT_TELEGRAM_URL}?text=${encodeURIComponent(text)}`;
}
